<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-row>
 

      <b-col sm="12" md="12">
        
        <b-card header-tag="header" >
          <div slot="header"  >
            <b-button  @click="regresar()" size="sm" variant="secondary"> Regresar a cuentas  </b-button>
          </div>
            <div slot="header" style="text-align:center;">
            <strong  v-if ="cuenta"> Expedientes de la cuenta {{cuenta}} </strong>
          </div>
          <b-row >
            <b-col sm="12" md="12">
              <p v-if="expedientes.length === 0">No hay expedientes capturados</p>
            </b-col>
            <b-col sm="12" md="6">
                   
              <v-client-table 
                    :columns="tabla.columns" 
                    :data="expedientes" 
                    :options="tabla.options">
                    <div style="min-width:fit-content; " slot="options" slot-scope="props" >
                      <b-dropdown 
                        id="ddown1" 
                        size="sm" 
                        variant="outline-primary" 
                        text="Opciones">
                        <!--ponerle permisos a los dropdown-->
                        <b-dropdown-item  @click="verExpediente(props.row._id)">Ver expediente</b-dropdown-item>
                        <b-dropdown-item  v-if="puedeEditar" @click="modificarExpediente(props.row._id)">Editar expediente</b-dropdown-item>
                        <b-dropdown-item v-if="puedeVerActas" @click="verActas(props.row._id)">Ver actas</b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </v-client-table>
                   
            </b-col>
            <b-col v-if="puedeAgregar" md="12" class="text-left">
              <b-button 
                size="sm" 
                variant="primary"
                @click="mostrar = true">
                Nuevo expediente
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <agregarExpediente
    
        v-if = " mostrar "
        :mostrar = 'mostrar'
        :editarExpediente="editarExpediente"
        :idCuenta="idCuenta"
        @cancelar="mostrar=false, editarExpediente=null"
        @guardar="guardar"
      />
  </div>
</template>

<script>


import axios from 'axios'
import Loader from '../Loader'
import agregarExpediente from './agregarExpediente.vue'
import { mapGetters } from "vuex";

export default {
  name: 'listadoExpedientes',
  components: {
   Loader,
   agregarExpediente
  },
  computed: {
    ...mapGetters(["httpURL",  "sessionToken",  "permisos",  "role"]),
    puedeEditar(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 220) !== -1 )
        return true;
      else return false;
    },
   puedeAgregar(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 216) !== -1 )
        return true;
      else return false;
    },
    puedeVerActas(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 218) !== -1 )
        return true;
      else return false;
    },
  },
  data: function () {
    return {
        idCuenta:null,
        cuenta:null,
        enviando: false,
        expedientes: [],
        imagenBack:null,
        mostrar:false,
        tabla: {
         
          columns: ['options','folio'],
          options: {
            headings: {
              options:'',
              folio: 'Folio',
             
            },
            resizableColumns:false,

            filterable: ['folio'],
            perPage: 20,
            perPageValues: [10, 20, 30, 50, 100],
            
            texts: {
                  count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
                  first: 'Primero',
                  last: 'Último',
                  filter: "Buscar:",
                  filterPlaceholder: "Ingrese...",
                  limit: "Registros:",
                  page: "Página:",
                  noResults: "No hay registros.",
                  filterBy: "Filtrando por {column}",
                  loading: 'Cargando...',
                  defaultOption: 'Select {column}',
                  columns: 'Columns'
              }
        }
        },
        editarExpediente:null,

    }
  },
  created(){
    this.idCuenta= this.$route.params.id;
    if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 217) == -1) this.$router.go(-1);
    this.enviando = true;
    axios.get(this.httpURL+'/proteccionBomberos/cuenta/'+this.idCuenta+'/expedientes',
                {headers:{token:this.sessionToken}})
        .then(res => {
            //console.log(res.data);
            this.expedientes = res.data.cuenta.expedientes;
            this.cuenta = res.data.cuenta.noCuenta;
           
            this.enviando = false;
        })
        .catch(error => {
          this.enviando = false;
          //console.log(error);
           swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
           this.enviando = false;
        });
  },
  methods: {
    regresar(){
         this.$router.replace({path: '/proteccionBomberos/cuentas'});
      },
    verExpediente(id){
      this.$router.replace({path: '/proteccionBomberos/cuenta/'+this.idCuenta+'/expediente/'+id});
    },
    verActas(id){
      this.$router.replace({path: '/proteccionBomberos/cuenta/'+this.idCuenta+'/expediente/'+id+'/actas'});
    },
    modificarExpediente(id){
      this.editarExpediente = this.expedientes.find(x => x._id.toString() == id)      
      this.mostrar = true;
    },
    guardar(data){
      this.mostrar = false;
      this.expedientes.push(data)

    },
    actualizar(data){
      this.mostrar = false;
      let index = this.expedientes.findIndex(x =>x._id.toString()==data._id)
      if(index !== -1) this.expedientes.splice(index,1,data)
    },
   
    }
}
</script>

<style scoped>
.table-responsive {
  overflow-x: visible !important ;
}
</style>
